import { sizes } from '@lmc/common/constants'
import { getNominative } from '@lmc/common/utils'
import dayjs from 'dayjs'
import { find } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Actions from '../../../../actions'

import { DateRangePicker, Spinner } from '../../../../components/generic'
import Operations from '../../../../operations'
import Selectors from '../../../../selectors'
import { history as routerHistory } from '../../../../store'
import { withRouter } from '../../../../withRouter'
import CarePlanHistoryList from './components/CarePlanHistoryList'

export class CarePlanHistoryScreen extends React.Component {
  state = {
    carePlanId: null
  }

  componentDidMount() {
    const {
      fetchCarePlan,
      router: { params }
    } = this.props
    fetchCarePlan(params.care_plan_id)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.carePlan !== nextProps.carePlan) {
      this.fetchHistory(nextProps.carePlan)
    }
  }

  fetchHistory = (carePlan) => {
    const {
      fetchHistory,
      router: { params }
    } = this.props
    if (params.id && carePlan) {
      this.setState({ carePlanId: carePlan.carePlanId })
      fetchHistory(params.id, carePlan.carePlanId)
    }
  }

  setDateRange = ({ startDate, endDate }) => {
    const {
      fetchHistory,
      setDateRange,
      router: { params }
    } = this.props

    setDateRange({
      startDate: startDate ? dayjs(startDate).startOf('day') : null,
      endDate: endDate ? dayjs(endDate).endOf('day') : null
    })
    fetchHistory(params.id, this.state.carePlanId)
  }

  handleClickRevision = (revision_id) => {
    const {
      router: {
        params: { id, care_plan_id }
      }
    } = this.props

    routerHistory.push(
      `/residents/${id}/care-plans/${care_plan_id}/history/${revision_id}`
    )
  }

  renderHeader = () => {
    const {
      carePlan,
      dateRange,
      router: {
        params: { id, care_plan_id }
      }
    } = this.props

    let adlName
    if (carePlan && carePlan.carePlanAdl) {
      adlName = carePlan.customName || carePlan.carePlanAdl.name
    }

    return (
      <div>
        <Link
          id="back-to-careplan"
          to={`/residents/${id}/care-plans/${care_plan_id}`}
        >
          <span className="octicon octicon-chevron-left" />{' '}
          {getNominative(this.props.carePlanNominative, 'Care Plan')}
        </Link>
        <div style={styles.adlNameContainer}>
          <h2 id="adl-name" style={styles.adlName}>
            History {adlName && `- ${adlName}`}
          </h2>
        </div>
        <div style={styles.datePicker}>
          <DateRangePicker
            startDate={dateRange && dateRange.startDate}
            endDate={dateRange && dateRange.endDate}
            maximumNights={1000}
            blockFuture
            onChange={this.setDateRange}
          />
        </div>
      </div>
    )
  }

  render() {
    const { carePlan, carers, dateRange, history, carePlanNominative } =
      this.props
    if (!carePlan || !carers) return <Spinner />

    return (
      <div style={styles.wrapper}>
        {this.renderHeader()}
        <div style={styles.list}>
          {dateRange && history ? (
            <CarePlanHistoryList
              carers={carers}
              history={history}
              onClickRevision={this.handleClickRevision}
              carePlanNominative={carePlanNominative}
            />
          ) : (
            <Spinner />
          )}
        </div>
      </div>
    )
  }
}

const styles = {
  adlName: {
    marginBottom: 0
  },
  adlNameContainer: {
    paddingTop: 35
  },
  datePicker: {
    marginTop: 25
  },
  divider: {
    height: 2,
    marginTop: 8,
    width: '100%'
  },
  list: {
    marginTop: 20
  },
  wrapper: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    paddingTop: 25,
    paddingBottom: 80
  }
}

CarePlanHistoryScreen.propTypes = {
  carePlan: PropTypes.object,
  carers: PropTypes.array,
  dateRange: PropTypes.object,
  fetchCarePlan: PropTypes.func.isRequired,
  fetchHistory: PropTypes.func.isRequired,
  history: PropTypes.object,
  setDateRange: PropTypes.func.isRequired
}

const mapStateToProps = (state, props) => {
  return {
    carePlan: find(state.data['care-plans'], {
      id: props.router.params.care_plan_id
    }),
    carers: state.data.carers,
    dateRange: state.carePlans.historyDateRange,
    history: Selectors.groupCarePlansHistoryByDate(state),
    carePlanNominative: state.global.home.preferredCarePlansNominative
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCarePlan: (id) => dispatch(Operations.loadListItem('care-plans', id)),
    fetchHistory: (resident, carePlanId) =>
      dispatch(Operations.fetchCarePlanHistory(resident, carePlanId)),
    setDateRange: (range) =>
      dispatch(Actions.setCarePlanHistoryDateRange(range))
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CarePlanHistoryScreen)
)
